import {
  createContext,
  useContext,
  useRef,
  type ReactNode,
  type RefObject,
} from "react";
import { cn } from "@somethings-ui/core";

const ActionPanelScrollContext =
  createContext<RefObject<HTMLDivElement | null> | null>(null);

export function ActionPanelScrollProvider({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  const scrollRef = useRef<HTMLDivElement>(null);
  return (
    <ActionPanelScrollContext.Provider value={scrollRef}>
      <div
        ref={scrollRef}
        className={cn("subtle-scrollbar flex min-h-0 flex-1 flex-col overflow-y-auto", className)}
      >
        {children}
      </div>
    </ActionPanelScrollContext.Provider>
  );
}

export function useActionPanelScrollRef(): RefObject<HTMLDivElement | null> {
  const scrollRef = useContext(ActionPanelScrollContext);
  if (!scrollRef) {
    throw new Error(
      "useActionPanelScrollRef must be used within ActionPanelScrollProvider",
    );
  }
  return scrollRef;
}
